// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoCarousel_root__sUtI2","textStack":"VideoCarousel_textStack__q9PEf","videoCard":"VideoCarousel_videoCard__JvAPe"};